import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

/**
 * Control Center — Document Category Mapping (TOW-207).
 *
 * A document type holds at most one category, so the mapping is a single
 * nullable id going in and a single nullable category object coming back —
 * never an array. The category list itself is read through
 * `getAttachmentTypeCategories` (modules/order/orderDocumnet.js), which the
 * order Documents filter already uses.
 *
 * Full contract: docs/document-category-mapping-api.md
 */

export const createAttachmentTypeCategory = (category) => {
  return api.post(
    URLS.attachmentTypeCategory,
    { category },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const updateAttachmentTypeCategory = ({ id, category }) => {
  return api.put(
    URLS.attachmentTypeCategory,
    { id, category },
    {
      headers: {
        needsToken: true
      }
    }
  );
};

export const deleteAttachmentTypeCategory = (categoryId) => {
  return api.delete(URLS.attachmentTypeCategory, {
    params: { id: categoryId },
    headers: {
      needsToken: true
    }
  });
};

export const getDocumentTypeCategories = ({
  page = 1,
  limit = 20,
  query = null,
  categoryIds = [],
  unmapped = false
}) => {
  return api.get(URLS.documentTypeCategories, {
    params: {
      page,
      limit,
      ...(query && { query }),
      ...(categoryIds?.length && { categoryIds: categoryIds.join(',') }),
      ...(unmapped && { unmapped: true })
    },
    headers: {
      needsToken: true
    }
  });
};

/**
 * Updates a document type's mapping. `categoryId` of null clears the category
 * assignment, `eventCode` of null clears the Resware event code. Only the keys
 * passed in are sent, so a category edit can't wipe an event code (or the
 * reverse) by omitting it.
 */
export const updateDocumentTypeCategory = ({
  documentTypeId,
  categoryId,
  eventCode
}) => {
  return api.put(
    URLS.documentTypeCategory,
    {
      documentTypeId,
      ...(categoryId !== undefined && { categoryId }),
      ...(eventCode !== undefined && { eventCode })
    },
    {
      headers: {
        needsToken: true
      }
    }
  );
};
